<template>
    <div class="change-price flex-column">
        <div
            class="t-shop-product mp-promos__productWrapper mp-promos__productWrapperModalAccept"
            :id="`mp-promos__productWrapper-${product.id}`"
        >
            <label
                :for="`input-number--${product.id}`"
                class="text-sm typo--primary mb-sm-0 mb-3"
            >
                <div class="d-flex align-items-center">
                    <template v-if="product.main === false">
                        <p v-if="product.ean" class="text-xs typo--gray">
                            EAN: {{ product.ean }}
                        </p>
                    </template>
                    <template v-else>
                        <div class="c-fig c-fig--promos c-fig--product">
                            <img :src="dict.image.urls.small" class="c-fig__img" />
                        </div>
                        <div class="text-break d-flex flex-column ml-2">
                            {{ dict.name }}

                            <p v-if="dict.ean" class="text-xs typo--gray">
                                EAN: {{ dict.ean }}
                            </p>
                            <p
                                v-if="isMargin"
                                class="text-xs typo--gray d-flex d-md-none"
                            >
                                Marża %: {{ margin }}
                                <a-icon
                                    v-tooltip="$store.getters.getWholesalePriceMarginTooltip('all')"
                                    class="ml-1"
                                    style="width: 14px; height: 14px"
                                    icon="Info"
                                />
                            </p>
                        </div>
                    </template>
                </div>
            </label>

            <div
                v-if="isMargin"
                class="d-md-flex d-none align-items-center justify-content-between gap-0-5"
            >
                <label class="form-label d-md-none mb-0">
                    Marża %
                    <a-icon
                        v-tooltip="`
                            Marża obliczona na podstawie maksymalnej ceny det., max. ceny hurt.,
                            max. ceny hurt. w Eurocash Cash & Carry, max. ceny hurt. z dystrybucji
                            zewnętrznej i zwrotu z promocji. Więcej informacji znajduje się
                            w szczegółach promocji.
                        `"
                        class="ml-1"
                        style="width: 14px; height: 14px"
                        icon="Info"
                    />
                </label>
                <div
                    v-text="margin"
                    class="d-flex align-items-center"
                    style="min-height: 50px;"
                />
            </div>

            <div
                v-if="showLocalCode"
                class="change-price__input input-currency input-currency-sm"
            >
                <label class="form-label d-md-none mb-0">Kod lokalny</label>
                <local-code
                    class="d-flex flex-column local-code"
                    :text="localCode"
                    :invalid="!!localCodeError"
                    :invalid-feedback="invalidCodeFeedback"
                    :invalid-icon="false"
                    :disabled="product.ean_present"
                    :product="product"
                    @input="sendLocalCode($event)"
                    @blur="checkIfEanExists()"
                />
            </div>

            <div
                v-if="promo.type === PROMO_TYPES.QUOTA && changeByMerchantsGroup"
                class="change-price__input input-currency input-currency-sm"
            >
                <label class="form-label d-md-none mb-0">Rabat brutto</label>
                <money-input
                    :id="`input-number-kw--${product.id}`"
                    :price="-product.discount_amount"
                    :disabled="true"
                    :positive-number-validation="false"
                    :small="true"
                />
            </div>

            <div
                v-if="showPrice"
                class="change-price__input input-currency input-currency-sm"
            >
                <label
                    v-if="$store.getters.isWeight(promo.type)"
                    class="form-label d-md-none mb-0"
                >
                    Cena w promocji <span class="nowrap">za KG</span>
                </label>
                <label v-else class="form-label d-md-none mb-0">Cena w promocji</label>
                <money-input
                    small
                    :id="`input-number--${product.id}`"
                    :placeholder="
                        +(+product.maximum_price).toFixed(2)
                    "
                    :max-promotional-price="+product.maximum_price"
                    :price="productPrice"
                    @onChange="sendPrice($event)"
                />
            </div>
            <slot name="showMoreBtn"></slot>
        </div>

        <div
            v-if="altEanError"
            class="w-100 d-flex mb-3"
            style="max-width: none;"
        >
            <alt-ean-warning :alt-ean-error="altEanError" class="ml-auto" />
        </div>
        <slot></slot>
    </div>
</template>

<script>
import AltEanWarning from '@/components/promotions/altEans/AltEanWarning.vue'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    data() {
        return {
            price: null,
            originalPrice: null,
            margin: null
        }
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        promo: {
            type: Object,
            required: true
        },
        merchantId: {
            type: Number,
            required: false
        },
        groupIdx: {
            type: Number,
            default: 0
        },
        previewType: {
            type: String,
            default: ''
        },
        changeByMerchantsGroup: {
            type: Boolean,
            default: false
        }
    },

    components: {
        AltEanWarning
    },

    watch: {
        priceChange(val) {
            this.$emit('priceChange', val)
        },
        productPrice() {
            this.price = this.productPrice
        }
    },
    computed: {
        priceChange() {
            return this.productPrice !== this.originalPrice
        },
        promoGroupId() {
            return this.promo.groupId
        },
        subscriptionProduct() {
            return this.$store.getters.getSelectedSubscriptionProduct(
                this.promo.id,
                this.product.id,
                this.merchantId,
                this.groupIdx,
                this.promoGroupId,
                this.$route.name === 'labels'
            )
        },
        localCode() {
            let alternativeEan
            if (this.promo.equalLocalCodes) {
                const subs = this.promo.subscriptionsEqualPrices.priceGroups[
                    this.groupIdx
                ]

                if (!subs && !subs.length) return

                const products = []
                subs.forEach(sub => {
                    const prodId = this.product.promo_dict_product_id || this.product.id
                    const prod = (sub.products || []).find(
                        el => el.id === prodId
                    )
                    products.push(prod)
                })
                const firstEan = products[0]?.alternativeEan
                if (products.every(p => p.alternativeEan === firstEan)) {
                    alternativeEan = firstEan
                }
            } else {
                const sub = this.promo.subscriptions.find(
                    el => el.merchant_id === this.merchantId
                )

                if (!sub) return

                const prodId = this.product.promo_dict_product_id || this.product.id
                const prod = (sub.products || []).find(
                    el => el.productId === prodId
                )
                alternativeEan = prod?.alternativeEan
            }
            return alternativeEan
        },
        productPrice() {
            let sub
            let productPrice
            if (this.promo.subscriptionsEqualPrices.equalPrices) {
                sub = this.promo.subscriptionsEqualPrices.priceGroups[
                    this.groupIdx
                ][0]
            } else {
                sub = this.promo.subscriptions.find(
                    el => el.merchant_id === this.merchantId
                )
            }
            if (sub) {
                const prod = sub.products?.find(
                    el => el.productId === this.product.id
                )
                productPrice = prod?.productPrice
            }
            return +productPrice || +this.product.maximum_price
        },

        showLocalCode() {
            let show = false
            if (this.promo.all_eans_present === false) {
                if (this.changeByMerchantsGroup) {
                    if (this.promo.equalLocalCodes) {
                        show = true
                    }
                } else {
                    if (!this.promo.equalLocalCodes) {
                        show = true
                    }
                }
            }
            return show
        },
        showPrice() {
            let show = false
            if (this.changeByMerchantsGroup) {
                if (this.promo.subscriptionsEqualPrices?.equalPrices) {
                    show = true
                }
            } else {
                if (!this.promo.subscriptionsEqualPrices?.equalPrices) {
                    show = true
                }
            }
            if (
                this.promo.type === PROMO_TYPES.QUOTA ||
                this.promo.type === PROMO_TYPES.SALES_TARGET
            ) {
                show = false
            }
            return show
        },
        localCodeError() {
            const shouldValidate = !this.$store.getters.getLocalCodesValidation
            const error = this.$store.getters.getLocalCodeError({
                promoId: this.promo.id,
                groupId: this.promo.promo_group_id,
                productId: this.product.id,
                merchantId: this.merchantId
            })

            if (error?.type === 'emptyEan' && shouldValidate) {
                return null
            } else {
                return error
            }
        },
        invalidCodeFeedback() {
            if (this.localCodeError) {
                return this.localCodeError?.error
            } else {
                return ''
            }
        },
        isMargin() {
            const { previewType, promo, product } = this

            if (product.main === false) {
                return false
            }

            if (previewType === 'labels') {
                return false
            }

            if (!this.$store.getters.isMarginType(promo.type)) {
                return false
            }

            return true
        },
        altEanError() {
            if (!this.localCode || !this.showLocalCode) {
                return undefined
            }

            if (!this.subscriptionProduct.eanErrors) {
                return undefined
            }

            let err
            if (this.merchantId) {
                err = this.subscriptionProduct.eanErrors.find(
                    el =>
                        +el.alternative_ean === +this.localCode &&
                        el.merchant_id === this.merchantId &&
                        el.ean !== this.product.ean
                )
            } else {
                err = this.subscriptionProduct.eanErrors.filter(
                    el => el.ean !== this.product.ean
                )[0]
            }

            return err
        },
        dict() {
            return this.product.dict_product
        }
    },
    methods: {
        sendLocalCode(event) {
            this.$store.dispatch('setSubscriptionAlternativeEan', {
                promoId: this.promo.id,
                productId: this.product.id,
                alternativeEan: event,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.promoGroupId,
                promo: this.promo
            })
        },
        sendPrice(event) {
            this.margin = this.$functions.calculateMargin({
                product: this.product,
                price: event
            })
            this.price = event
            this.$store.dispatch('setSubscriptionProductPrice', {
                product: this.product,
                newPrice: this.price,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.promoGroupId,
                promo: this.promo
            })
            this.$store.dispatch('checkPricesErrors')
        },

        async checkIfEanExists() {
            if (!this.$store.getters.isProductEansPermission) return

            if (!this.localCode) {
                this.$store.dispatch('setProductEansErrors', {
                    promotion: this.promo,
                    merchantId: this.merchantId,
                    productId: this.product.id,
                    groupIdx: this.groupIdx,
                    selected: true,
                    eanErrors: null
                })
                return
            }

            const res = await this.$store.dispatch('checkIfEansExist', [
                { alternative_ean: this.localCode }
            ])

            this.$store.dispatch('setProductEansErrors', {
                merchantId: this.merchantId,
                promotion: this.promo,
                productId: this.product.id,
                groupIdx: this.groupIdx,
                selected: true,
                eanErrors: res
            })
        }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
        this.price = +this.productPrice
        this.originalPrice = this.price

        if (this.product.main === false) {
            return
        }
        this.margin = this.$functions.calculateMargin({
            product: this.product,
            price: this.price
        })
    }
}
</script>

<style lang="scss">
.change-price__input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}
</style>